import { Component, Input, SimpleChanges } from '@angular/core';
import { VhQueryAutoWeb, VhEventMediator } from 'vhautowebdb';
import { forkJoin } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { AtwUpdateDbComponent } from 'vhobjects-service/src/services';
import { FunctionService} from 'vhobjects-service/src/services';

@Component({
  selector: 'app-frame-room-by-category-view-more-config',
  templateUrl: './frame-room-by-category-view-more-config.component.html',
  styleUrls: ['./frame-room-by-category-view-more-config.component.scss']
})
export class AtwFrameRoomByCategoryViewMoreConfig extends AtwUpdateDbComponent {
  @Input() objectChoosing: any; // lấy giá trị data trả vể từ page
  @Input() device: any; // xác định device là desktop hay mobile
  @Input() position: any; // xác định position là desktop hay mobile
  @Input() class: any; // là dữ liệu desktop_class hoặc mobile_portrait_class từ database
  @Input() config: any; // là dữ liệu desktop_config hoặc mobile_portrait_config từ database
  @Input() type: any; // xem đang ở page hay admin
  isViewAll: boolean = false;
  isCollapsed: boolean = false;
  public currentViewAll: any = {};
  public stylesField = [
    {
      title: 'dieu_chinh_vien_khung',
      index: 1,
    },
    {
      title: 'dieu_chinh_vien_phan_tu',
      index: 2,
    },
    {
      title: 'dieu_chinh_hieu_ung',
      index: 3,
    },
    {
      title: 'dieu_chinh_vien_nut_xem_them',
      index: 4,
    },
  ];
  public optionsBackground = [
    {
      label: 'Hình nền',
      value: 'image',
    },
    {
      label: 'Màu nền',
      value: 'color',
    },
  ];

  effect_hover = [];
  customize = [];


  constructor(
    public vhQueryAutoWeb: VhQueryAutoWeb,
    private http: HttpClient,
    public vhEventMediator: VhEventMediator,
    public functionService: FunctionService,
  ) {
    super(vhQueryAutoWeb, vhEventMediator, functionService);
  }


  ngOnInit(): void {
    forkJoin([
      this.http.get('assets/data/effects/frame-products.json'),
    ]).subscribe(([effects]: any) => {
      this.effect_hover = effects;
    });
  }


  ngOnChanges(changes: SimpleChanges): void {
    if (changes) {
      if (changes.device) this.device = changes.device.currentValue;
    }
  }


  /**
   * hàm này nhận sk thay đổi width height từ component app-width-height-config truyền về
   * @param event width hieght của element sau khi thay đổi
   */
  changeWidthHeight(event) {
    if (event.width) this.class['frame-product-category-view-more']['width'] = event.width + 'px';
    if (event.height) this.class['frame-product-category-view-more']['height'] = event.height + 'px';
    this.updateClass();
    this.vhEventMediator.notifyOnConfigChanged({
      status: 'update-object-selected-ruler',
      code: this.objectChoosing._id,
    });
  }

  /**
   * Hàm này set customize mở phần mở rộng của config từ choose-animations-config truyền về
   * @param event customize sau khi thay đổi
   */
  openAnimationDetail(event) {
    this.customize = event;
    this.openViewAll(this.stylesField[2]);
  }


  /* -------------------- CÁC HÀM UPDATE DATA LÊN DATABASE -------------------- */

  // /**
  //  * Cập nhật config lên database
  //  */
  // updateConfig() {
  //   this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_config']: this.config })
  //     .then((bool: any) => {

  //     });
  // }

  // /**
  //  * Cập nhật class lên database
  //  */
  // updateClass() {
  //   this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_class']: this.class })
  //     .then((bool: any) => {

  //     });
  // }

  // /**
  //  * Cập nhật staticdata lên database
  //  */
  // updateStaticData() {
  //   this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { staticdata: this.objectChoosing.staticdata })
  //     .then((bool: any) => {

  //     });
  // }


  /* ------------------------ CÁC HÀM XỬ LÍ MENU CONFIG ----------------------- */

  // xử lý chỉ mở được 1 menu 1 lần
  openMap: { [name: string]: boolean } = {
    menu1: true,
    menu2: false,
    menu3: false,
    menu4: false,
    menu5: false,
    menu6: false,
    menu7: false,
    menu8: false,
    menu9: false,
    menu14: false,
  };
  openHandler(value: string): void {
    for (const key in this.openMap) {
      if (key !== value) {
        this.openMap[key] = false;
      }
    }
  }

  /**
   * Hàm này dùng để mở rộng phần cấu hình.
   * @param field_text : trả về phần tử được chọn của mảng style_field
   */
  openViewAll(field_text) {
    this.currentViewAll = field_text;
    this.isViewAll = !this.isViewAll;
  }

}
